import { removeEmptyEntries } from "../../utils/objectUtils";
import { API } from "./types";
import { fetchResource } from "./utils";

export const getCampaigns = (options?: { limit?: number; offset?: number }) =>
  fetchResource<API.Campaign[]>(`/campaigns/list`, {
    queryParams: removeEmptyEntries(options),
  });

export const getCampaignsByIds = (ids: number[]) =>
  fetchResource<API.Campaign[]>(`/campaigns/list/${ids.join(",")}`);
